<template>
  <div class="typing-box"
       @keydown="onkeydown"
       tabindex="0"
       :class="{
        'unfocused': !activated
      }"
  >
    <span class="char" v-for="(ch, i) in content" :key="i"
          :class="{
             'current': i === cursorPosition,
             'wrong': states[i] === constants.WRONG,
             'correct': states[i] === constants.CORRECT,
             'no-input': states[i] === constants.NO_INPUT,
             'skipped': states[i] === constants.SKIPPED
          }"
    >{{ ch !== '\n' ? ch : "↓ " }}</span>

    <div class="cover" v-if="!activated">
      <p>Focus to activate</p>
    </div>
  </div>
</template>

<script>
import {constants} from '@/constant'
import isPrintableKeyEvent from "is-printable-key-event"

export default {
  name: 'TypingBox',
  props: {
    content: {
      type: String,
      default: ""
    },
    activated: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    'keyEvent'
  ],
  watch: {
    content(newContent) {
      for (let i = 0; i < newContent.length; i++)
        this.states[i] = constants.NO_INPUT
      this.cursorPosition = 0
    }
  },
  setup() {
    return {
      constants: constants,
      isPrintableKeyEvent: isPrintableKeyEvent
    }
  },
  data() {
    return {
      states: new Array(10000).fill(constants.NO_INPUT),
      cursorPosition: 0,
      blur: false,
      previousKeystrokeTimestamp: 0,
      previousKey: "",
      deltaTime: -1,
    }
  },
  methods: {
    created() {
    },
    mounted() {
    },
    updateKeystrokeTimestamp(timestamp, key, expected) {
      const delta = timestamp - this.previousKeystrokeTimestamp
      if (delta < constants.MAX_KEYSTROKE_INTERVAL) { // continuous input
        this.deltaTime = delta / 1000
      } else { // long pause
        this.deltaTime = -1
      }
      this.$emit('keyEvent', {
        previousKeystrokeTimestamp: this.previousKeystrokeTimestamp,
        delta: this.deltaTime,
        newKey: key,
        previousKey: this.previousKey,
        expectedKey: expected
      })
      this.previousKeystrokeTimestamp = timestamp
      this.previousKey = key
    },
    onkeydown(event) {
      event.preventDefault()
      if (event.key === 'r' && event.ctrlKey) // refresh
        location.reload()

      console.log(event.key)
      if (!this.isPrintableKeyEvent(event) && event.key !== "Enter") // non-printable
        return

      if (this.cursorPosition >= this.content.length) // done
        return

      const char = event.key
      const now = Date.now()
      const expected = this.content[this.cursorPosition]
      if (char === this.content[this.cursorPosition]) { // forward
        this.states[this.cursorPosition] = constants.CORRECT
        this.cursorPosition++
      } else if (char === this.content[this.cursorPosition + 1]) { // skip
        this.states[this.cursorPosition] = constants.SKIPPED
        this.states[this.cursorPosition + 1] = constants.CORRECT
        this.cursorPosition += 2
      } else if (char === this.content[this.cursorPosition - 1]) {
        this.states[this.cursorPosition - 1] = constants.SKIPPED
      } else { // wrong
        this.states[this.cursorPosition] = constants.WRONG
        this.cursorPosition++
      }
      this.updateKeystrokeTimestamp(now, char, expected)
      // auto scroll
      if (char === ' ') {
        const el = document.querySelector(`.char:nth-child(${this.cursorPosition})`)
        el.scrollIntoView({
          behavior: 'auto',
          block: 'center',
          inline: 'center'
        });
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
* {
  font-family: monospace;
}

.typing-box.unfocused {
  background-color: #eeeeeeaa;

  .char:not(.cover) {
    filter: blur(1px);
  }

  .cover {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    content: 'Focus to activate';
    background-color: #eeeeee33;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.char {
  user-select: none;
}

.current {
  background-color: lightgreen;
}

.no-input:not(.current) {
  color: #939399;
}

.wrong {
  background-color: #f17474;
  color: white;
}

.correct {
  background-color: #cbf6cb;
}

.skipped {
  background-color: #e5c522;
  color: white;
}
</style>
